export default "__VITE_ASSET__B5VSu5u5__"